import type { WalletProvider } from '@dynamic-labs-sdk/client/core';

import type { EvmWalletProvider } from '../EvmWalletProvider.types';

export const isEvmWalletProvider = (
  walletProvider: WalletProvider
): walletProvider is EvmWalletProvider => walletProvider.chain === 'EVM';
